import styled from "styled-components";

export const HelpBubbleWrapper = styled.a`
    width: 16px;
    height: 16px;

    margin-left: 12px;

    display: flex;
    align-items: center;
    justify-content: center;
`;
